import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';

import { customizationKeys } from './customizationKeys';
import { type TenantCustomization, tenantCustomizationSchema } from './useGetCustomization';

interface SaveCustomizationInput {
  // Canonical JSON string (or null to clear → revert to defaults).
  customizationJson: string | null;
}

// PUT /api/v1/tenants/me/customization — saves the branding blob. Backend
// enforces Tenant.Edit (403 for Editor/Viewer, surfaced as a toast) and
// validates the shape (400 on bad colours/junk). Response carries the saved
// state (+ fresh presigned logo URL) so we prime the cache from it.
export function useSaveCustomization() {
  const queryClient = useQueryClient();

  return useMutation<TenantCustomization, Error, SaveCustomizationInput>({
    mutationFn: async (input) => {
      const raw = await apiClient.put('api/v1/tenants/me/customization', { json: input }).json();
      return tenantCustomizationSchema.parse(raw);
    },
    onSuccess: (data) => {
      queryClient.setQueryData(customizationKeys.current(), data);
    },
  });
}
